// import { COMPONENTS } from "../../lib/constants";

export const FreespinStatusbarGrid = {
	size: 100,
	gap: 0,
	name: 'FreespinStatusbarGrid',
	padding: {
		top: 3,
		bottom: 0,
		left: 5,
		right: 5,
		portrate: {
			top: 3,
			bottom: 3,
			left: 3,
			right: 3
		}
	},
	main: [
		{
			name: 'FreespinStatusbarGrid-grid',
			size: 70,
			type: 'PortrateGridController',
			config: {
				name: 'quest',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 14
					},
					{
						name: 'bg',
						size: 6
					}
				]
			}
		}
	],
	landscape: [
		{
			name: 'FreespinStatusbarGrid-grid',
			size: 65,
			type: 'PortrateGridController',
			config: {
				name: 'quest',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 15
					},
					{
						name: 'bg',
						size: 5
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'FreespinStatusbarGrid-grid',
			size: 73,
			type: 'PortrateGridController',
			config: {
				name: 'quest',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 15
					},
					{
						name: 'bg',
						size: 5
					}
				]
			}
		}
	]
};
